/** Keep protected columns visible at their original positions. */
export function constrainColumns(columns: any[], defaults: any[]): any[] {
  const moving = columns.filter(column => !defaults.some(item => item.columnKey === column.columnKey && item.disableReorder));
  const result = [...moving];
  defaults.forEach((column, index) => {
    if (column.disableReorder) result.splice(index, 0, { ...column, displayed: true });
  });
  return result;
}

export function restoreColumns(defaults: any[], saved: { key: string; displayed?: boolean }[]): any[] {
  const ordered = saved.map(item => {
    const column = defaults.find(column => column.columnKey === item.key);
    return column ? { ...column, displayed: item.displayed } : undefined;
  }).filter(Boolean);
  defaults.forEach(column => { if (!ordered.some(item => item.columnKey === column.columnKey)) ordered.push({ ...column }); });
  return constrainColumns(ordered, defaults);
}
